export const marginBreakdownFields = [
    {
      fieldName: "totalFund",
      fieldTitle: "Total Amount",
      validationObj: {
        required: 'Please Enter Amount',
      },
      fieldType: "text",
    },
  ];